import Homepage from "@/Pages/AcessoProfessor/HomePage.vue";

export default [
  {
    path: "/acesso-professor/home",
    name: "acessoProfessor.home",
    component: Homepage,
  },
];
